import script from "./Marquee.vue?vue&type=script&setup=true&lang=js"
export * from "./Marquee.vue?vue&type=script&setup=true&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=5333abc0&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5333abc0"]])

export default __exports__